import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ActionSheetController } from '@ionic/angular';
import { AlertController,NavController } from '@ionic/angular';
import { HelperService } from 'src/app/services/helper.service';
// import { Geolocation } from '@ionic-native/geolocation/ngx';
import {IonContent} from '@ionic/angular';

@Component({
  selector: 'app-today-offer',
  templateUrl: './today-offer.page.html',
  styleUrls: ['./today-offer.page.scss'],
})
export class TodayOfferPage implements OnInit {
  userId: any;
  productList: any = []
  category: any = "";
  page_number: number = 1;
  limit = 14;
  productId: any;
  cityName: any;
  bannerType: any;
  isLoadData = false;
  storeId: any;
  searchParams: any;
  searchResultData: any = [];
  noDataImage: boolean = false;
  productFound: boolean = false;
  isLoading: boolean = false;
  city = localStorage.getItem('city');
  count: any;
  isPromoActiveFlag: any;
  articleNumber: any;
  imageName: any;
  check: any = 0;
  constructor(private routerActivate: ActivatedRoute,  private router: Router, private authService: StoreService,   public actionSheetController: ActionSheetController, public alertController: AlertController, private navController:NavController,private toast: HelperService
    ){}
  ngOnInit() {
    this.routerActivate.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.category = this.router.getCurrentNavigation().extras.state.cat;
        this.productId = this.router.getCurrentNavigation().extras.state.productId;
        this.cityName = this.router.getCurrentNavigation().extras.state.city;
        this.bannerType = this.router.getCurrentNavigation().extras.state.bannerOfferType;
        this.storeId = this.router.getCurrentNavigation().extras.state.storeId;
        this.isPromoActiveFlag = this.router.getCurrentNavigation().extras.state.isPromoActiveFlag; 
        this.articleNumber = this.router.getCurrentNavigation().extras.state.articleNumber;
        this.imageName = this.router.getCurrentNavigation().extras.state.imageName;
      }
    });
    this.productList=[];
    this.page_number=1;
      this.userId = localStorage.getItem('userId');
      this.listOfProduct(false, "", this.category, this.productId, this.cityName, this.bannerType, this.storeId)
      // console.log("enter in viewDid enter function",this.category)
  }
  listOfProduct(isFirstLoad, event, category: any, productId: any, cityName: any, bannerType: any, storeId: any) {
    this.isLoading = true;
    const promoListobj = {
      cat: category,
      page: this.page_number,
      limit: this.limit,
      productId: productId,
      cityName: cityName,
      bannerType: bannerType,
      userId: this.userId,
      storeId: this.storeId,
      zip: "",
      city: this.city,
      articleNumber: this.articleNumber
    }
    // console.log("slider data sending cat param",promoListobj)
    this.authService.todaySepicalOffer(promoListobj).subscribe((data: any) => {
      console.log(data.msg)
      this.isLoading = false;
      if (data.msg.code == 2 && this.productFound==false) {
        this.noDataImage = true
        this.toast.presentToast(data.msg,2000,'bottom')
      } else if (data.msg.code == 3 && this.productFound==false) {
        this.noDataImage = true
        //this.toast.presentToast(data.msg,2000,'bottom')
      }
      else {
        for (let i = 0; i < data.msg.length; i++) {
          //console.log(i, data.length)
          this.productFound = true;
          this.count=0;
          for(let j=0;j<this.productList.length;j++)
          {
            if(this.productList[j].articleNumber==(data.msg[i].articleNumber)){
             this.count++;
            }
          }
          if(this.count==0)
          {
            this.productList.push(data.msg[i]);
          }
    
         // this.productList.push(data[i]);
        }
        // for (let i = 0; i < data.length; i++) {
        //   //console.log(i,data.length)
        //   this.productFound = true;
        //   this.productList.push(data[i]);
        // }
        if (isFirstLoad)
          event.target.complete();
        this.page_number++;
        console.log("product detail API hit", this.productList)
      }
      if (this.productList.length > 0) {
        this.check = 0;
      } else {
        this.check = 1;
        console.log("hekkkk")
      }
    }, (error: any) => {
      this.toast.presentToast(error,2000,'bottom')
    });
  }
  doInfinite(event) {
    this.listOfProduct(true, event, this.category, this.productId, this.cityName, this.bannerType, this.storeId);
  }
 

  goHome() {
    this.router.navigate(['/feed'])
  }
  goBack() {
    this.navController.pop();
  }
  // ionViewDidLeave() {
  //   //console.log("Call--ionViewDidLeave")
  //   this.productList = [];
  //   this.page_number = 1;
  //   this.searchResultData = [];
  // }

  handleAddToCart(productObj) {
    let promoListobj = {
      productdetails: productObj,
      userId: this.userId
    }
    this.authService.addToCart(promoListobj)
      .subscribe((result: any) => {
        this.toast.presentToast("Product added in your cart",2000,'bottom')
      }, (error: any) => {
      });
  }
  onClick(productItem: any) {
    let qty = 1;
    // console.log("product item object clickable product",productItem);
    let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, backPageFlag: { cat: this.category, productId: this.productId, city: this.cityName, bannerOfferType: this.bannerType, backPageFlagInfo: "1", storeId: this.storeId, articleNumber:this.articleNumber,imageName:this.imageName } } };
    this.router.navigate(['/product-detail'], navigationParams);
  }
  fetchCatStoreTerm(peoplename) {
    this.searchParams = peoplename;
    
      let navigationParams: NavigationExtras = { state: {cat:this.category,city:this.cityName,  backPageFlag: { cat: this.category, productId: this.productId, city: this.cityName, bannerOfferType: this.bannerType, backPageFlagInfo: "1", storeId: this.storeId,articleNumber:this.articleNumber,imageName:this.imageName } } };
      this.router.navigate(['/search-product'], navigationParams);
   
  }

  notifications(){
    this.router.navigate(['/wishlist'])
  }
  home(){
    this.router.navigate(['/'])
  }
  
}
